/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiAlbumsIdQueryResponse, GetApiAlbumsIdPathParams, GetApiAlbumsId400, GetApiAlbumsId401, GetApiAlbumsId403, GetApiAlbumsId404, GetApiAlbumsId500 } from "../../types/GetApiAlbumsId.ts";
import { getApiAlbumsIdQueryResponseSchema } from "../../zod/AlbumSchemas/getApiAlbumsIdSchema.ts";

function getGetApiAlbumsIdUrl({ id }: { id: GetApiAlbumsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/albums/${id}` as const }  
  return res
}

/**
 * @summary Метод получения альбома по идентификатору.
 * {@link /api/albums/:Id}
 */
export async function getApiAlbumsId({ id }: { id: GetApiAlbumsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiAlbumsIdQueryResponse, ResponseErrorConfig<GetApiAlbumsId400 | GetApiAlbumsId401 | GetApiAlbumsId403 | GetApiAlbumsId404 | GetApiAlbumsId500>, unknown>({ method : "GET", url : getGetApiAlbumsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiAlbumsIdQueryResponseSchema.parse(res.data)
}